import _typeof from "@babel/runtime/helpers/esm/typeof";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
import { c as _c } from "react-compiler-runtime";
import React, { Suspense, lazy } from 'react';
import useItemAddedModalStore from "../../../store/item-added-modal/use-store";

/* Eagerly start chunk downloads when this module loads (once the parent
   CartItemAddedModal chunk has arrived) so the content chunks are likely
   already cached by the time the modal renders and product data resolves. */
var customContentImport = Promise.resolve().then(function () {
  return _interopRequireWildcard(require('./ProductAddedModalCustomContent'));
});
var contentImport = Promise.resolve().then(function () {
  return _interopRequireWildcard(require('./ProductAddedModalContent'));
});

// Prevent unhandled-rejection events if a chunk fetch fails before
// React.lazy consumes the promise (see ItemAddedModalWrapper.js).
customContentImport["catch"](function () {});
contentImport["catch"](function () {});
var LazyProductAddedModalCustomContent = /*#__PURE__*/lazy(function () {
  return customContentImport;
});
var LazyProductAddedModalContent = /*#__PURE__*/lazy(function () {
  return contentImport;
});
var ProductAddedModalProductCard = function ProductAddedModalProductCard() {
  var $ = _c(3);
  var _useItemAddedModalSto = useItemAddedModalStore(_temp),
    modalDesignViewId = _useItemAddedModalSto.designViewId;
  if (modalDesignViewId) {
    var _t;
    if ($[0] !== modalDesignViewId) {
      _t = /*#__PURE__*/React.createElement(Suspense, {
        fallback: null
      }, /*#__PURE__*/React.createElement(LazyProductAddedModalCustomContent, {
        designViewId: modalDesignViewId
      }));
      $[0] = modalDesignViewId;
      $[1] = _t;
    } else {
      _t = $[1];
    }
    return _t;
  }
  var t0;
  if ($[2] === Symbol["for"]("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/React.createElement(Suspense, {
      fallback: null
    }, /*#__PURE__*/React.createElement(LazyProductAddedModalContent, null));
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default ProductAddedModalProductCard;
function _temp(t0) {
  var designViewId = t0.designViewId;
  return {
    designViewId: designViewId
  };
}